import React, { useMemo, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import dayjs from 'dayjs';

import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';
import Select from 'components/Select/desktop';
import Button from 'components/Button';
import { formateNumber } from 'shared/helpers';

import TableRow from '../TableRow/TableRow';
import TableHead from '../TableHead/TableHead';

import './Table.scss';

const b = block('table-promotions');

const Table = ({ currentPage, onPageClick, onItemsOnPageChanged, handleDeletePromotion }) => {
  const totalCount = useSelector(state => state.reports.paymentHistory.details.totalCount, shallowEqual);
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { promotions } = useSelector(state => state.bonusProgram, shallowEqual);
  const itemsOnPageFilters = [
    { value: 10, name: '10' },
    { value: 25, name: '25' },
    { value: 50, name: '50' },
    { value: 100, name: '100' },
  ];
  const [itemsOnPage, setItemsOnPage] = useState({ value: 10, name: '10' });

  const selectItemChangedHandler = itemValue => {
    setItemsOnPage({ value: itemValue, name: itemValue });
    onItemsOnPageChanged(itemValue);
  };

  const rows = useMemo(
    () =>
      promotions.items.map(item => (
        <TableRow handleDeletePromotion={handleDeletePromotion} key={item.id} item={item} locale={locale} />
      )),
    [promotions, locale],
  );

  return (
    <div className={b()}>
      <div className={b('header')}>
        <span className={b('header-left')}>{locale.result}:</span>
        <div className={b('page-count')}>
          <div className={b('page-count-title')}>{locale.elementsOnPage}:</div>
          <div className={b('page-count-select')}>
            <Select paginator items={itemsOnPageFilters} activeItem={itemsOnPage} onChange={selectItemChangedHandler} />
          </div>
        </div>
      </div>
      <div className={b('table')}>
        <TableHead locale={locale} />
        <div className={b('tbody')}>
          {!!rows.length ? rows : <div className={b('no-results')}>{locale.noResults}</div>}
        </div>
        <div className={b('paginator-wrapper')}>
          <div className={b('extra-info')}>
            {formateNumber(promotions.count || 0)} {locale.records}
          </div>
          <PaginatorSwitcher
            count={promotions.count}
            currentPage={currentPage}
            onPageClick={onPageClick}
            itemsOnPage={itemsOnPage}
          />
        </div>
      </div>
    </div>
  );
};

Table.propTypes = {
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onItemsOnPageChanged: PropTypes.func,
  onPageClick: PropTypes.func.isRequired,
};

export default Table;
